import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = { children: ReactNode }
type State = { failed: boolean }

/** Keep one page failure from leaving users with a completely blank portal. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Browser details are useful to developers without exposing an error stack
    // in the user-facing screen. API errors remain in the normal portal logs.
    console.error('Portal render failed', error, info)
  }

  render() {
    if (this.state.failed) {
      return <main className="startup-error"><h1>Portal page could not load</h1><p>Refresh the portal. If this continues, open a support ticket and include the time of the error.</p><button onClick={() => window.location.reload()}>Reload portal</button></main>
    }
    return this.props.children
  }
}
